























































import Utils from "@/utils";
import Vue from "vue";
import storeHelper from "../../store/store-helper";

export default Vue.extend({
    name: "UserAvatar",
    props: {
        text: String,
        isAnonymousUser: Boolean
    },
    data: () => {
        return {};
    },
    components: {},
    created() {},
    computed: {
        initials() {
            let initials = "";

            if (!this.text) return "";

            this.text?.split(" ").forEach(x => {
                if (x != "") initials += x.charAt(0);
            });
            return initials.substring(0, 2).toUpperCase();
        },
        isIE(): boolean {
            return Utils.isIE11;
        },
        hasMenu(): Boolean {
            return !!this.$slots.default;
        }
    }
});
